import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
}
export function AccordionItem({
  title,
  children,
  isOpen: defaultOpen = false
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="mb-4 bg-white rounded-2xl shadow-sm border border-brand-pastelpink overflow-hidden" data-id="element-227" data-mp="2n3p8tjxu6kft">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-228" data-mp="2i54ge6ott51x">
        <span className="font-semibold text-brand-black pr-4" data-id="element-229" data-mp="2w2jb9qxum51a">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 text-brand-pink" data-id="element-230" data-mp="2s3k03olixc1e">
          <ChevronDown size={20} data-id="element-231" data-mp="xr3xcxrxsg1a" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-232" data-mp="3g5ezoo2szokf">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-233" data-mp="3l36qtfvmj6nk">
            <div className="px-6 pb-4 text-gray-600 text-sm leading-relaxed border-t border-brand-babypink pt-4" data-id="element-234" data-mp="3mfiri81jg4t">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}